/**
 * Reusable carousel navigation arrows component
 * @param {function} onLeftClick - Handler for left arrow click
 * @param {function} onRightClick - Handler for right arrow click
 * @param {boolean} isLeftDisabled - Whether left arrow is disabled
 * @param {boolean} isRightDisabled - Whether right arrow is disabled
 * @param {string} size - Size variant: "large" (default) or "small"
 * @param {string} variant - Style variant: "default" or "outline" (white bg with blue border)
 * @param {string} className - Additional CSS class for the container
 * @param {string} arrowClassName - CSS class for the arrow buttons
 * @param {object} style - Additional inline styles for the container
 */
const CarouselArrows = ({
  onLeftClick,
  onRightClick,
  isLeftDisabled = false,
  isRightDisabled = false,
  size = "large",
  variant = "default",
  className = "",
  arrowClassName = "btn btnBox btnBefore",
  style = {},
}) => {
  return (
    <div className={`carousel-arrows ${size} ${variant} ${className}`} style={style}>
      <span
        className={arrowClassName}
        data-icon="keyboard_arrow_left"
        onClick={onLeftClick}
        style={{
          pointerEvents: isLeftDisabled ? "none" : "auto",
          opacity: isLeftDisabled ? 0.5 : 1,
          cursor: isLeftDisabled ? "default" : "pointer",
        }}
        role="button"
        aria-label="Previous"
        aria-disabled={isLeftDisabled}
      />
      <span
        className={arrowClassName}
        data-icon="keyboard_arrow_right"
        onClick={onRightClick}
        style={{
          pointerEvents: isRightDisabled ? "none" : "auto",
          opacity: isRightDisabled ? 0.5 : 1,
          cursor: isRightDisabled ? "default" : "pointer",
        }}
        role="button"
        aria-label="Next"
        aria-disabled={isRightDisabled}
      />
    </div>
  );
};

export default CarouselArrows;

